<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <a class="nav-link " v-bind="$attrs" type="button" data-bs-toggle="collapse" aria-expanded="false" :href="`#${refer}`" @click="isExpanded = !isExpanded">
    <div class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center me-2">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text ms-1">
      {{ text }}
    </span>
  </a>
  <div :id="refer" class="collapse">
    <ul class="nav nav-sm flex-column">
      <slot name="nav-child-item" />
    </ul>
  </div>
</template>

<script>

  export default {
    name: "SidenavCollapseItem",
    props: {
      refer: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    }
  };

</script>